<div class="wcrard p-3 mb-3 comaparison-slider-card">
  <div>
   <p class="f-18 font-weight-600 mb-3">Competitive Benchmarking</p>
   <ul>
    <li>Talent Attrition Analysis</li>
    <li>Industry Positioning</li>
    <li>Skill Gap Evaluation</li>
    <li>Market Trends Assessment</li>
    <li>Custom Reports & Recommendations</li>
   </ul>
  </div>

  <div class="wc-slider-section">
        <div class="skeleton-wrapper" *ngIf="!sliders?.length">
    <div class="skeleton"></div>
    <div class="skeleton"></div> <!-- Two skeleton rows -->
  </div>
    <div id="carouselExampleControls" class="carousel slide" data-ride="carousel" *ngIf="sliders?.length">

  <div class="carousel-inner" >
    <div class="carousel-item" *ngFor="let group of sliders ; let i = index" [ngClass]="i==0?'active':'' " >
      <div class="carousel-compare-card pointer" *ngFor="let row of group.rows" (click)="openCompanyCompare(row)">
        <div class="carousel-compare-company" *ngFor="let item of [row.first, row.second]">
          <div class="company-logo">
            <img src="{{item?.companylogo}}" alt="">
          </div>
          <div class="comp-info">
            {{item?.company_name}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <a data-testid="auto-app-company-comparison-slider-a-1" class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </a>
  <a data-testid="auto-app-company-comparison-slider-a-2" class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </a> -->
</div>
  </div>
</div>
